module.exports = __webpack_public_path__ + "d4bb655d07591559e417030519d6fa20.woff";